import { ListingSummaryDetailsFragment } from 'listing-details/components/ListingSummaryDetails/ListingSummaryDetails.types';
import { currencyFormatter } from '../../../../shared/helpers';

export const getPricingDetailLabel = ({
    pricing: { alternateRentFrequencyPrice, pricePerFloorAreaUnit }
}: ListingSummaryDetailsFragment): string | null => {
    let detailLabelValue = null;

    // Pricing Detail Condition
    if (alternateRentFrequencyPrice) {
        detailLabelValue = `${currencyFormatter.format(
            alternateRentFrequencyPrice.internalValue
        )} ${alternateRentFrequencyPrice.rentFrequencyLabel}`;
    } else if (pricePerFloorAreaUnit) {
        detailLabelValue = `(${currencyFormatter.format(
            pricePerFloorAreaUnit.internalValue
        )}/${pricePerFloorAreaUnit.unitsLabel})`;
    }

    return detailLabelValue;
};
